import { createMutationHelper } from '@utils/swr'
import queryString from 'query-string'
import { type CreatePopupClickNoShowQueryParams } from '../types/apiRequest'
import { type FortuneApis } from '../types/apis'

interface PathParamsId {
  id: string
}

const {
  useMutation,
} = createMutationHelper<FortuneApis['post']['popupClickNoShow'], never, PathParamsId & CreatePopupClickNoShowQueryParams>({
  client: 'eCommerce',
  key: '/popups',
  fetcher: (url, { arg, client }) => {
    const { id, campaign_id, project_code, country_code } = arg
    const query = queryString.stringify({
      campaign_id,
      project_code,
      country_code,
    }, {
      skipNull: true,
      skipEmptyString: true,
    })
    return client.post(`${url}/${id}/click-no-show${query ? `?${query}` : ''}`)
  },
})

export const useApiCreatePopupClickNoShow = useMutation
